
import { useParams } from "react-router-dom"

import { useFirebase } from "@meddbriefer/mdb-firebase"
import { getScenarioByID } from "@meddbriefer/scenario-data"

import { useScenarioEditor } from "./ScenarioEditorContext"


import BreadCrumbs from "../ScenarioTypeEditor/Breadcrumbs"
import SaveButton from "../ScenarioTypeEditor/SaveButton"

export default function ProblemsLayout({breadcrumbs=[], children}) {
    const {db} = useFirebase()
    const {scenarioId} = useParams()
    const {scenario, saveScenario} = useScenarioEditor()

    const clickHandler = async (event) => {
        // update ONLY the problems-related content to the db
        const scen = await getScenarioByID(db, scenarioId)
        // add in the problems-related content
        scen.problems = scenario.problems
        scen.solutions = scenario.solutions
        scen.actions = scenario.actions
        await saveScenario(scen)
    }
    return (
        <>
            <BreadCrumbs crumbs={breadcrumbs} />
            <SaveButton
                label="Save changes to Problems and Solutions"
                haveChanges={true}
                clickHandler={clickHandler}
            />
            {children}
            <SaveButton
                label="Save changes to Problems and Solutions"
                haveChanges={true}
                clickHandler={clickHandler}
            />
        </>
    )
}
